import React from 'react';
import { ICategoryPositionItemV2 } from 'types';
import { categoryTypes } from 'appConstants';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import Text from 'components/Text/Text';
import { ImgUploaderByPreSignedUrl } from 'components/ImgUploader/ImgUploaderByPreSignedUrl';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: ICategoryPositionItemV2;
	positionNumber: number;
	dragHandleProps: DraggableProvidedDragHandleProps | undefined;
}

export const Item: React.FC<IProps> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const categoryRowClasses = classNames(style.category, style.row);
	const imgWrapperClass = classNames(style.imgWrapper);
	const categoryNameClasses = classNames(style.categoryName);
	const categoryTypeRowClasses = classNames(style.categoryType, style.row);

	const categoryTypeName = categoryTypes.find((el) => el.categoryID === data.type)?.categoryName || null;

	return (
		<div className={containerClasses}>
			<div className={categoryRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<div className={imgWrapperClass}>
					<ImgUploaderByPreSignedUrl loaderSize="small" preSignedUrl={data.preSignedUrl} />
				</div>
				<Text className={categoryNameClasses} translationKey={data.name} withTooltip={true} />
			</div>
			<Text
				className={categoryTypeRowClasses}
				translationNameSpace="form"
				translationKey={categoryTypeName}
				withTooltip={true}
			/>
		</div>
	);
};
